import { compact } from "lodash";
import { EMPTY } from "constants/common";
import { AiccPromptModel } from "types/model/aiccPrompt";
import { AiccSandboxSettings } from "types/model/aiccPromptSandbox";

export const settingsLine = (
  { modelId, reasoningEffort, temperature }: AiccSandboxSettings,
  modelsById: Record<string, AiccPromptModel>
) =>
  compact([
    (modelId && modelsById[modelId]?.name) || modelId || EMPTY,
    reasoningEffort && `effort ${reasoningEffort}`,
    temperature === undefined ? "no temperature" : `temperature ${temperature}`,
  ]).join(" · ");
